import React, { Component } from 'react'
import AWSAPI from '../../../common/AWSAPI'
import Config from '../../../Config'
import Loading from '../../../common/component/Loading'

class Dashboard extends Component {
  constructor (props) {
    super(props)
    this.state = {isCompanyCountLoaded: false, isCompanyUserCountLoaded: false, companyCount: 0}
    this.apiUrl = Config.adminApiUrl.userManagement
  }
  componentWillMount () {
    this.loadCompanyCount()
    this.loadCompanyUserCount()
    this.loadEstimationCount()
  }
  loadCompanyCount (onSuccess) {
    const params = {
      userRole: 'companyAdmin',
      command: 'list'
    }
    AWSAPI.apiPost('admin',
      this.apiUrl,
      params,
      (res) => {
        if (res.body && res.body.hasOwnProperty('Users')) {
          this.setState({
            isCompanyCountLoaded: true,
            companyCount: res.body.Users.length
          })
        }
      }
    )
  }
  loadCompanyUserCount (onSuccess) {
    const params = {
      userRole: 'companyUser',
      command: 'list'
    }
    AWSAPI.apiPost('admin',
      this.apiUrl,
      params,
      (res) => {
        if (res.body && res.body.hasOwnProperty('Users')) {
          this.setState({
            isCompanyUserCountLoaded: true,
            companyUserCount: res.body.Users.length
          })
        }
      }
    )
  }
  loadEstimationCount () {
    const params = {
      command: 'getCount'
    }
    AWSAPI.apiPost('admin',
      Config.adminApiUrl.estimation,
      params,
      (res) => {
        if (res.body && res.body) {
          this.setState({
            isEstimationCountLoaded: true,
            estimationCount: res.body.data
          })
        }
      }
    )
  }
  onDashButtonClicked (name) {
    switch (name) {
      case 'companyList':
        this.props.history.push('/admin/company')
        break
      case 'informationList':
        this.props.history.push('/admin/information')
        break
      case 'sharedFileList':
        this.props.history.push('/admin/shared_files')
        break
      case 'defaultSetting':
        this.props.history.push('/admin/default_setting')
        break
      case 'adminUserList':
        this.props.history.push('/admin/admin_user')
        break
      case 'passwordChange':
        this.props.history.push('/admin/password_change')
        break
      case 'emaiChange':
        this.props.history.push('/admin/email_change')
        break
      case 'notificationSetting':
        this.props.history.push('/admin/notification_setting_change')
        break
      case 'surveySetting':
        this.props.history.push('/admin/survey_setting')
        break
      default:
        break
    }
  }
  onHelpLinkClicked (helpId) {
    const link = document.createElement('a')
    link.target = '_blank'
    link.href = '/admin/help/' + helpId
    link.rel = 'noopener noreferrer'
    link.click()
  }
  render () {
    if (!this.state.isCompanyCountLoaded || !this.state.isCompanyUserCountLoaded || !this.state.isEstimationCountLoaded) {
      return <Loading />
    }
    return (
      <div>
        <section className='nav nav-page'>
          <div className='container'>
            <div className='row'>
              <div className='span7'>
                <header className='page-header'>
                  <h3>マイページ<br />
                    <small>こちらから全ての作業を開始できます。</small>
                  </h3>
                </header>
              </div>
              <div className='page-nav-options'>
                <div className='span9' />
              </div>
            </div>
          </div>
        </section>
        <section className='page container'>
          <div className='row'>
            <div className='span8'>
              <div className='blockoff-left'>
                <legend className='lead'>ご利用状況</legend>
                <p>現在のご利用状況は以下です。</p>
                <table style={{textAlign: 'center', margin: '10px auto'}}>
                  <tbody>
                    <tr>
                      <th>登録企業数</th><th>登録企業ユーザ数</th><th>登録見積書件数</th>
                    </tr>
                    <tr>
                      <td style={{width: '120px'}}>{this.state.companyCount}</td><td style={{width: '120px'}}>{this.state.companyUserCount}</td><td style={{width: '120px'}}>{this.state.estimationCount}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className='blockoff-left'>
                <legend className='lead'>ご利用方法</legend>
                <p>利用シーンに合わせて、以下のガイドをご用意しております。</p>
                <ul>
                  <li><a onClick={(e) => this.onHelpLinkClicked('help007', e)}>パスワードを変更する</a></li>
                  <li><a onClick={(e) => this.onHelpLinkClicked('help008', e)}>メールアドレスを変更する</a></li>
                  <li><a onClick={(e) => this.onHelpLinkClicked('help009', e)}>メール通知を受信しないように設定する</a></li>
                  <li><a onClick={(e) => this.onHelpLinkClicked('help010', e)}>サポート対象のホームページ閲覧ソフトChromeをダウンロードする</a></li>
                </ul>
              </div>
            </div>
            <div className='span8'>
              <div className='box'>
                <div className='box-header'>
                  <i className='icon-bookmark' />
                  <h5>ショートカット</h5>
                </div>
                <div className='box-content'>
                  <h6>各機能へのショートカット</h6>
                  <div className='btn-group-box'>
                    <a onClick={(e) => this.onDashButtonClicked('companyList')}><button className='btn kw-btn-info'><i className='icon-star icon-large' /><br /><span>企業管理</span></button></a>
                    <a onClick={(e) => this.onDashButtonClicked('informationList')}><button className='btn kw-btn-success'><i className='icon-info-sign icon-large' /><br /><span>お知らせ</span></button></a>
                    <a onClick={(e) => this.onDashButtonClicked('sharedFileList')}><button className='btn kw-btn-warning'><i className='icon-cloud icon-large' /><br /><span>共有ﾌｧｲﾙ管理</span></button></a>
                    <a onClick={(e) => this.onDashButtonClicked('defaultSetting')}><button className='btn kw-btn-primary'><i className='icon-cog icon-large' /><br /><span>初期値設定</span></button></a>
                    <a onClick={(e) => this.onDashButtonClicked('adminUserList')}><button className='btn kw-btn-default'><i className='icon-cog icon-large' /><br /><span>事務局管理者</span></button></a>
                    <a onClick={(e) => this.onDashButtonClicked('passwordChange')}><button className='btn kw-btn-inverse'><i className='icon-lock icon-large' /><br /><span>ﾊﾟｽﾜｰﾄﾞ</span></button></a>
                    <a onClick={(e) => this.onDashButtonClicked('emaiChange')}><button className='btn kw-btn-danger'><i className='icon-envelope-alt icon-large' /><br /><span>ﾒｰﾙｱﾄﾞﾚｽ変更</span></button></a>
                    <a onClick={(e) => this.onDashButtonClicked('notificationSetting')}><button className='btn kw-btn-info'><i className='icon-bell icon-large' /><br /><span>通知受信可否設定</span></button></a>
                    <a onClick={(e) => this.onDashButtonClicked('surveySetting')}><button className='btn kw-btn-default'><i className='icon-file icon-large' /><br /><span>ｱﾝｹｰﾄ設定</span></button></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    )
  }
}

export default Dashboard



// WEBPACK FOOTER //
// ./src/admin/pages/secure/Dashboard.js